import api from './api.js'

// ant分页获取协会会员列表
export function memberProTable(params){
    return api.get('/resource-portal/api/v1/association/member/proTable',params);
}
// 获取协会会员详情
export function memberDetalis(uuid){
    return api.get(`/resource-portal/api/v1/association/member/${uuid}`);
}

export function associationInfo(code) {
    return api.get(`/resource-portal/api/v1/association/program/code/${code}`)
}

export function associationProgram(params){
    return api.get("/resource-portal/api/v1/association/program/list",params)
}
// 保存商家西悉尼
// export function saveShopSettled(params){
//     return api.post('/resource-print/api/v1/shop/settled',params);
// }



// WEBPACK FOOTER //
// ./src/utils/associationApi.js